import { render, staticRenderFns } from "./InformationSuccess.vue?vue&type=template&id=845a5802&scoped=true&"
import script from "./InformationSuccess.vue?vue&type=script&lang=js&"
export * from "./InformationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./InformationSuccess.vue?vue&type=style&index=0&id=845a5802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845a5802",
  null
  
)

export default component.exports